/*----------------------------------
- DOMAINS GITHUB BANNER
----------------------------------*/

/**
 * The banner a GitHub dataset visit shows under the title block (`?github_intent=radar|project`), as the mock draws
 * it (`dm-gh`): a card on the butter wash with the path's tag (`ud-tag--edition`) and the persona and plan tag, then
 * the title and the line from `githubIntent.ts`'s experience. It only says what the page armed; the sign-up modal
 * opening by itself is the page's effect, unchanged.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { Tag } from '@uniquedomains/components/kit/tag/Tag';

import { DOMAINS_GITHUB_PERSONA_LABELS } from '@/client/catalogs/landing/domains/pageCopy';
import type { GithubIntentExperience } from '../lib/githubIntent';

/*----------------------------------
- TYPES
----------------------------------*/

type DomainsGithubBannerProps = {
    banner: NonNullable<GithubIntentExperience['banner']>;
    primaryAction: GithubIntentExperience['primaryAction'];
};

/*----------------------------------
- COMPONENT
----------------------------------*/

const DomainsGithubBanner = ({ banner, primaryAction }: DomainsGithubBannerProps) => (
    <div class="dm-gh">
        <div class="dm-gh__tags">
            <Tag tone="edition">{banner.eyebrow}</Tag>
            <Tag>
                {DOMAINS_GITHUB_PERSONA_LABELS[primaryAction.persona]} · {primaryAction.planLabel}
            </Tag>
        </div>
        <p class="dm-gh__t">{banner.title}</p>
        <p class="dm-gh__d">{banner.description}</p>
    </div>
);

export default DomainsGithubBanner;
